<template>
    <ContentLayout>
        <header class="mb-6 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
            <div>
                <Heading title="Messages" />
            </div>

            <Button class="w-full md:w-auto" @click="onComposeEmail">
                <AppIcon
                    name="pen-to-square"
                    class="mr-2 h-[18px] w-[18px]"
                    stroke-width="2.5"
                />
                <span>Compose Email</span>
            </Button>
        </header>

        <div class="flex flex-col items-start sm:flex-row sm:items-center sm:justify-end">
            <div
                v-if="subtabs.length"
                class="inline-flex w-full justify-start rounded bg-slate-200 p-1 sm:w-auto sm:justify-end"
            >
                <button
                    v-for="tab in subtabs"
                    :key="tab.key"
                    class="flex grow rounded px-3 py-2 font-semibold leading-tight transition duration-150 ease-in-out hover:text-foreground focus:outline-none focus:ring-0 sm:px-4"
                    :class="{
                        'bg-white text-foreground shadow-sm': activeSubtab === tab.key,
                        'text-slate-600': activeSubtab !== tab.key,
                    }"
                    @click="setActiveSubtab(tab.key)"
                >
                    <span class="mx-auto text-sm capitalize"
                        >{{ tab.label }}
                        <span
                            v-if="tab.count !== undefined"
                            class="ml-1 whitespace-nowrap text-xs font-bold text-slate-500"
                        >
                            ( {{ tab.count }} )
                        </span>
                    </span>
                </button>
            </div>
        </div>

        <div class="mt-6">
            <EmailConversations
                ref="emailConversations"
                :active-subtab="activeSubtab"
                @render-subtabs="onRenderSubtabs"
            />
        </div>
    </ContentLayout>
</template>

<script>
import { nextTick } from 'vue'
import { ContentLayout } from '@/components/ui/layouts'
import { Button } from '@/components/ui/button'
import { Heading } from '@/components/ui/typography'
import EmailConversations from '@/partials/tables/EmailConversations.vue'

export default {
    name: 'MessagesPage',

    metaInfo: {
        title: 'Messages',
    },

    components: {
        ContentLayout,
        Button,
        Heading,
        EmailConversations,
    },

    data() {
        return {
            subtabs: [],
            activeSubtab: null,
        }
    },

    methods: {
        setActiveSubtab(subtab) {
            this.activeSubtab = subtab
        },

        async onRenderSubtabs(tabs, activeSubtab) {
            await nextTick()
            this.subtabs = tabs
            this.activeSubtab = activeSubtab
        },

        onComposeEmail() {
            if (this.$refs.emailConversations) {
                this.$refs.emailConversations.openComposeModal()
            }
        },
    },
}
</script>
